exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#svg-tick .tick{stroke-dasharray:44;stroke-dashoffset:44}#svg-tick .tick-circle{stroke-dasharray:157.1;stroke-dashoffset:157.1;transform:rotate(320deg);transform-origin:50% 50%}#svg-tick.checked .tick{animation:tick-dash 1.5s .3s cubic-bezier(.19,1,.22,1) forwards 1}#svg-tick.checked .tick-circle{stroke-dashoffset:0}@-webkit-keyframes tick-dash{0%{stroke-dasharray:44}to{stroke-dashoffset:0}}@keyframes tick-dash{0%{stroke-dasharray:44}to{stroke-dashoffset:0}}@-webkit-keyframes tick-circle{0%{fill:none;stroke:none}to{fill:inherit}}@keyframes tick-circle{0%{fill:none;stroke:none}to{fill:inherit}}", ""]);

// exports
